import React from 'react';
import { observer } from 'mobx-react';
import { Label, Button } from '../../../common/materials';
import CreatableSelect from 'react-select/creatable';
import PasswordManagemntViewModel from './PasswordManagement.viewmodel';
import PasswordConfigView from './components/PasswordConfigView';
import { RadioGroup, Radio } from '@chakra-ui/react';

const SYSTEM_TYPES = ['UAT', 'PRE-PRD', 'PRD'] as const;
type SystemType = (typeof SYSTEM_TYPES)[number];

function PasswordManagement() {
    const {
        f1PasswordManagement,
        currentAdminCompany,
        companyOptions,
        userRole,
        company,
        onSelectCompany,
        onCheckSystemType,
        handleSearch,
        handleEdit,
        handleChange,
        fireSwal,
    } = PasswordManagemntViewModel();

    return (
        <React.Fragment>
            <div className="flex flex-col gap-4">
                <p className="text-2xl font-bold">Password Management</p>
                <div className="flex flex-col gap-4 bg-white p-4">
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-2 flex flex-col">
                            <Label>Company</Label>
                            <CreatableSelect
                                className="h-[32px]"
                                //options={companyOptions}
                                //value={company}
                                //onChange={selectedCompany => setCompany(selectedCompany)}
                                //isClearable
                                //isMulti
                                isDisabled={
                                    userRole === 'User' ||
                                    currentAdminCompany.length === 0 ||
                                    currentAdminCompany.length === 1
                                }
                                onChange={onSelectCompany}
                                options={companyOptions}
                                value={company}
                            />
                        </div>
                    </div>
                    <div className="mt-4 flex flex-col gap-1">
                        <Label>System Types</Label>
                        <RadioGroup>
                            <div className="flex gap-4">
                                {SYSTEM_TYPES.map(env => (
                                    <Radio
                                        value={env}
                                        key={env}
                                        colorScheme="primary"
                                        onChange={() => onCheckSystemType(env as SystemType)}
                                    >
                                        {env}
                                    </Radio>
                                ))}
                            </div>
                        </RadioGroup>
                    </div>
                    <div className="mt-2 grid grid-cols-8 gap-4">
                        <div className="col-span-1 flex gap-4">
                            <Button
                                className="col-span-1 flex-1 bg-primary-900 text-white"
                                onClick={handleSearch}
                            >
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="mt-4 bg-white">
                    <p className="text-lg font-semibold">Password Configuration</p>
                </div>
                <div className="bg-white p-4 border rounded">
                    <PasswordConfigView
                        source={f1PasswordManagement}
                        handleChange={handleChange}
                        fireSwal={fireSwal}
                    />
                </div>
                <div className="mt-2 grid grid-cols-8 gap-4" style={{ direction: "rtl" }}>
                    <div className="col-span-1 flex gap-4">
                        <Button
                            className="col-span-1 flex-1 bg-primary-900 text-white"
                            onClick={handleEdit}
                            disabled={!f1PasswordManagement}
                        >
                            Edit
                        </Button>
                    </div>
                </div>
            </div >
        </React.Fragment >
    );
};

export default observer(PasswordManagement);